<template>
    <div>
        <headers :title="titles"
                 :backType="backType"></headers>
        <template v-if="!loading">
            <div class="tab_list flex jb">
                <div class="item"
                     :class="active_tab==index?'active':''"
                     @click="choose_tab(index)"
                     v-for="(item,index) in tab_list"
                     :key="index">
                    <span>{{item}}</span>
                </div>
            </div>
            <template v-if="active_tab==0">
                <div class="tab_content"
                     v-if="chapter_list.length">
                    <div class="item"
                         v-for="(item,index) in chapter_list"
                         :key="index">
                        <div class="title flex ac"
                             @click="handleOpen(item)">
                            <div class="title_icon flex fc jc ac">
                                <div class="img">
                                    <img src="./img/icon_img2.png"
                                         v-if="item.active"
                                         class="big_icon">
                                    <img src="./img/icon_img1.png"
                                         v-else
                                         class="big_icon">
                                </div>
                            </div>
                            <p>{{item.name}}</p>
                        </div>
                        <div class="sub_list"
                             v-if="item.children&&item.active">
                            <div class="sub_item"
                                 v-for="(item2,index2) in item.children"
                                 :key="index2">
                                <div class="sub_title flex jb ac"
                                     @click="handleOpen(item2)">
                                    <div class="left flex jb ac">
                                        <div class="title_icon flex fc jc ac">
                                            <div class="img"
                                                 v-if="!item2.children">
                                                <img src="./img/icon_img5.png"
                                                     class="small_icon">
                                            </div>
                                            <div class="img"
                                                 v-else>
                                                <img src="./img/icon_img4.png"
                                                     v-if="item2.active"
                                                     class="big_icon">
                                                <img src="./img/icon_img3.png"
                                                     v-else
                                                     class="big_icon">
                                            </div>
                                        </div>
                                        <p>{{item2.name}}</p>
                                    </div>
                                    <div class="right"
                                         v-if="!item2.children">
                                        <img src="./img/icon_img6.png"
                                             alt="">
                                    </div>
                                </div>
                                <div class="sub_children"
                                     v-if="item2.children&&item2.active">
                                    <div class="sub_children_item flex jb ac"
                                         v-for="(item3,index3) in item2.children"
                                         @click="handleOpen(item3)"
                                         :key="index3">
                                        <div class="left flex jb ac">
                                            <div class="title_icon flex fc jc ac">
                                                <div class="img">
                                                    <img src="./img/icon_img5.png"
                                                         class="small_icon">
                                                </div>
                                            </div>
                                            <p>{{item3.name}}</p>
                                        </div>
                                        <div class="right">
                                            <img src="./img/icon_img6.png"
                                                 alt="">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <noResouse v-else></noResouse>
            </template>
            <template v-else>
                <div class="chapter">
                    <ul class="list"
                        v-if="!loading">
                        <li class="list_li"
                            v-for="(chapter,index) in list"
                            v-if="list.length>0">
                            <h3 @click="selectLi(chapter,index)">
                                <span>{{chapter.name}}</span>
                                <i :class="chapter.active?'up':''"
                                   v-if="chapter.children&&chapter.children.length>0"></i>
                            </h3>
                            <ul class="section"
                                v-if="chapter.active&&chapter.children">
                                <li class="section_li"
                                    v-for="item in chapter.children"
                                    @click="to_xcp(item)">{{item.name}}</li>
                            </ul>
                        </li>
                        <noResouse v-else></noResouse>
                    </ul>
                </div>
            </template>
        </template>
        <loadingS v-else></loadingS>
    </div>
</template>
<script>
import headers from 'COMPONENTS/base/header.vue';
import loadingS from 'COMPONENTS/base/tealoading.vue';
import noResouse from 'COMPONENTS/noResouse.vue';
export default {
    data () {
        return {
            backType: 0,
            titles: '选择章节',
            sid: this.$route.params.sid,
            bookId: this.$route.params.id,
            list: [],
            token: localStorage.getItem("Tbkt-Token"),
            loading: true,
            active_tab: 0,
            chapter_list: []
        }
    },
    components: {
        headers, loadingS, noResouse
    },
    async created () {
        this.choose_tab(this.active_tab)
    },
    computed: {
        tab_list () {
            if (this.sid == 22) {
                return ['预习情况']
            } else {
                return ['预习情况', '作业情况']
            }
        }
    },
    methods: {
        choose_tab (index) {
            this.active_tab = index
            if (index == 1) {
                this.get_chapter_list()
            } else {
                this.get_book_list()
            }
        },
        get_book_list () {
            this.$http.post(API_URL_TASK_API + '/preview/catalog/', {
                "sid": this.sid,
                "book_id": this.bookId
            }).then(res => {
                this.loading = false;
                if (res.data.response === 'ok') {
                    res.data.data.catalog_list.forEach(e => {
                        e.active = true
                        if (e.children) {
                            e.children.forEach(e2 => {
                                e2.active = true
                                if (e2.children) {
                                    e2.children.forEach(e3 => {
                                        e3.active = true
                                    });
                                }
                            });
                        }
                    });
                    this.chapter_list = res.data.data.catalog_list
                }
            })
        },
        get_chapter_list () {
            this.$http.post(API_URL_TASK_API + '/maths/check/book/bz/chapter', {
                "sid": this.sid == '22' ? '21' : this.sid, //初中数学22 使用sid=21来请求章节数据
                "book_id": this.bookId
            }).then(res => {
                this.loading = false;
                if (res.data.response === 'ok') {
                    this.list = res.data.data;
                }
            })
        },
        handleOpen (item) {
            if (item.children) {
                item.active = !item.active
            } else {
                this.to_xcp_previes(item)
            }
        },
        selectLi (item, i) {
            if (!item.children || item.children.length == 0) {
                this.to_xcp(item);
                return false;
            }
            item.active = !item.active;
            this.list.splice(i, 1, item);
        },
        to_xcp_previes (item) {
            let cid = null;
            if (this.sid == 21 || this.sid == 22) {
                cid = item.id
            } else {
                cid = item.ch_id
            }
            let { platform, app_version } = JSON.parse(localStorage.getItem('search')) || {};
            let url = `${VUE_URL_XCPTEA}/test/yx_detail/${this.sid}/${cid}?form=task&tbkt_token=${this.token}&platform=${platform}&app_version=${app_version}&v=${(+new Date())}`;
            location.href = url;
        },
        to_xcp (item) {
            let { platform, app_version } = JSON.parse(localStorage.getItem('search')) || {};
            let _paper_id = this.sid == '51' ? `&paper_id=${item.paper_id}` : '';
            let url = `${VUE_URL_XCPTEA}/test/inspect/${this.sid}/${item.id}?form=task${_paper_id}&tbkt_token=${this.token}&platform=${platform}&app_version=${app_version}&v=${(+new Date())}`;
            location.href = url;
        }
    },
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.tab_list {
    background: #fff;
    .item {
        flex: 0 0 50%;
        text-align: center;
        span {
            padding: 0 16px / $ppr;
            display: inline-block;
            line-height: 96px / $ppr;
            border-bottom: 4px / $ppr solid transparent;
            border-radius: 2px / $ppr;
        }
        &.active {
            span {
                color: #5e89ef;
                border-color: #5e89ef;
            }
        }
    }
}
.title_icon {
    width: 54px / $ppr;
    height: 54px / $ppr;
    position: relative;
    .img {
        background: #fff;
        border-radius: 100%;
        position: relative;
        z-index: 2;
        img {
            display: block;
            margin: 10px / $ppr;
        }
        .big_icon {
            width: 33px / $ppr;
            height: 33px / $ppr;
        }
        .small_icon {
            width: 20px / $ppr;
            height: 20px / $ppr;
        }
    }
    &:before {
        content: "";
        position: absolute;
        top: -108px / $ppr;
        left: 26px / $ppr;
        width: 2px;
        height: 250%;
        background: #eaeaea;
    }
}
.tab_content {
    padding: 24px / $ppr;
    .item {
        background: #fff;
        border-radius: 10px / $ppr;
        margin-bottom: 24px / $ppr;
        .title {
            padding: 39px / $ppr 30px / $ppr;
            .title_icon {
                &:before {
                    display: none;
                }
            }
            p {
                font-size: 32px / $ppr;
                color: #333;
                flex: 1;
            }
        }
        .sub_list {
            .sub_title {
                padding: 39px / $ppr 30px / $ppr;
                .left {
                    p {
                        font-size: 26px / $ppr;
                        color: #666;
                        flex: 1;
                    }
                }
                .right {
                    img {
                        width: 10px / $ppr;
                        height: 20px / $ppr;
                    }
                }
            }
            .sub_children {
                .sub_children_item {
                    padding: 39px / $ppr 30px / $ppr;
                    .left {
                        p {
                            font-size: 26px / $ppr;
                            color: #666;
                            flex: 1;
                        }
                    }
                    .right {
                        img {
                            width: 10px / $ppr;
                            height: 20px / $ppr;
                        }
                    }
                }
            }
        }
    }
}
.flex {
    display: flex;
}
.jb {
    justify-content: space-between;
}
.jc {
    justify-content: center;
}
.ac {
    align-items: center;
}
.fc {
    flex-direction: column;
}
.chapter {
    width: 100%;
    padding: 0 24px / $ppr 24px / $ppr;
    box-sizing: border-box;
    .list {
        .list_li {
            h3 {
                padding: 0 24px / $ppr;
                background: #fff;
                line-height: 102px / $ppr;
                height: 102px / $ppr;
                margin-top: 24px / $ppr;
                font-size: 30px / $ppr;
                color: #333;
                position: relative;
                z-index: 1;
                // font-weight:medium;
                i {
                    display: block;
                    width: 20px / $ppr;
                    height: 10px / $ppr;
                    background: url("./img/icon03.png");
                    background-size: 100% 100%;
                    position: absolute;
                    z-index: 2;
                    top: 50%;
                    right: 24px / $ppr;
                    margin-top: -5px / $ppr;
                }
                i.up {
                    background: url("./img/icon04.png");
                    background-size: 100% 100%;
                }
            }
        }
    }
    .section {
        padding-left: 56px / $ppr;
        background: #fff;
        font-size: 28px / $ppr;
        color: #999;
        li {
            line-height: 84px / $ppr;
            height: 84px / $ppr;
        }
    }
    .nolist {
        line-height: 400px / $ppr;
        text-align: center;
        font-size: 30px / $ppr;
        color: #999;
    }
}
</style>